import { css } from "../../../../styled-system/css";

export const popoverStyles = css({
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  border: "1px solid {colors.grey}",
  outline: "none",
  borderRadius: "standard",
  backgroundColor: "white",
});

export const tagChipStyles = css({
  display: "flex",
  gap: "xsmall",
  alignItems: "center",
  borderRadius: "15px",
  paddingY: "xxsmall",
  paddingX: "small",
  color: "white",
  fontSize: "small",
  fontWeight: 600,
  backgroundColor: "var(--tag-color)",
});
